import { useGlobalStore } from "@hooks/useGlobalStore";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEn from "../../constants/locales/en-US.json";
import translationZh from "../../constants/locales/zh-CN.json";

const resources = {
	"en-US": { translation: translationEn },
	"zh-CN": { translation: translationZh },
};

const initI18n = () => {
	const { getState } = useGlobalStore;
	i18n.use(initReactI18next).init({
		compatibilityJSON: "v3",
		resources,
		lng: getState().language || "en-US",
		fallbackLng: "en-US",
		interpolation: {
			escapeValue: false,
		},
	});
};

initI18n();

export default i18n;
